import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGER_BOOKINGS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteChargerBookingsAPI: any = createAsyncThunk(
  "deleteChargerBookings",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);

    try {
      const res = await axios.delete(CHARGER_BOOKINGS + "/" + rowId, {
        // headers: {
        //   token: JSON.parse(token),
        // },
        headers: commonHead,
      });
      return { stationDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
